import { Component, OnInit } from '@angular/core';
import { Business } from 'app/shared/models/business.model';
import { ApiService } from 'app/shared/services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-job',
  templateUrl: './job.component.html',
  styleUrls: ['./job.component.scss']
})
export class JobComponent implements OnInit {

  business: any = new Business()
  businessTypeCompany_Id = '6325ce10bc4b543c7a2429ad'
  jobTags: any[]=[];
  jobTag_id="678b3adb8a01ca89efb5f685";
  page=1
  totalItems=0
  pageSize:50
  constructor(public apiService: ApiService,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.getTagByTagCatgoryId() 
    this.getBusinessListByType()
  }
  getTagByTagCatgoryId() {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getTagByTagCatgoryId("678b3aa78a01ca89efb5f67a").subscribe((res: any) => {
      this.spinner.hide()
      this.jobTags = res.data
      console.log("jobTags",this.jobTags)
    })
  }
  onPageChange(page: number): void {
    this.page = page;
    this.getBusinessListByType();
  }
  getBusinessListByType() {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getBusinessByTypeId(this.businessTypeCompany_Id,this.jobTag_id,this.page,this.pageSize).subscribe((res: any) => {
      this.spinner.hide()
      this.business = res.data
      this.totalItems=res.total||res?.data?.length
      window.scroll(0,0)
      console.log("totalItems",this.totalItems)
    })
  }
}